import { useSearchParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useState, useContext } from "react";
import {
  Typography,
  Box,
  createTheme,
  ThemeProvider,
  Card,
  CardHeader,
  Stack,
} from "@mui/material";
//import Button from "../../../toolkit/Button";
import Label from "../../../../toolkit/Label";
import IconButton from "@mui/material/IconButton";
import baseTheme from "../../../../themes/baseTheme";
import trash1 from "../../../../icons/trash1.svg";
import edit from "../../../../icons/edit.svg";
import Avatar from "../../../../icons/Avatar.svg";
import React from "react";
import Button from "../../../../toolkit/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CircularProgress from "@mui/material/CircularProgress";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import axios from "../../../../utils/fvAxios";
import BaseURL from "../../../../utils/base-uri.json";
import { UsersContext } from "../../../../store/users-context";
import GetfVDateFormate from "../../../../utils/Genaricfunctions";
import { getOrgType, HasPermissions, HasScreenPermissions } from "../../../../utils/Token";
import INFO from "../../../../pages/commom/RouteUrlInfo.json";
import PER from "../../../../utils/Enums.json";
import { ToastContainer, toast } from "react-toastify";

const { palette } = baseTheme;
const theme = createTheme({});
const padding = "16px 24px";

export default function UsersListItem({
  status,
  headers = [],
  statusRoleMap,
  ...props
}) {
  const { setRefreshUserlist } = useContext(UsersContext);

  status = statusRoleMap[status];
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const [organization, setOrganization] = React.useState("");
  const OrganizationChange = (event) => {
    setOrganization(event.target.value);
  };
  const [userRoles, setUserRoles] = React.useState("");
  const handleChange = (event) => {
    setUserRoles(event.target.value);
  };
  const confirmDelete = async () => {
    setIsDeleting(true);
    const resp = await axios.post(
      BaseURL.settings.DeleteUser + "?userId=" + props.userId,
      {}
    );
    if (resp.data?.responseMessage === "Success") {
      setDeleteDialogOpen(false);
      setIsDeleting(false);
      // deleteUser();
      setRefreshUserlist((prev) => !prev);
    } else {
      setDeleteDialogOpen(false);
      setIsDeleting(false);
      toast.error("User can't be deleted as his/her data is tied with prequalification. Hence the user has been deactivated.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };
  const handleDialogClose = () => {
    setDeleteDialogOpen(false);
  };
  return (
    <>
      <ThemeProvider theme={theme}>
        <Box
          display="flex"
          padding={padding}
          borderBottom="solid 1px"
          borderColor={palette.grey[30]}
          alignItems="center"
        >
          <Box width={headers.find((h) => h.id === "userName")}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                "& svg": { m: 1.5 },
                "& hr": { mx: 0.5 },
              }}
            >
              <img
                style={{ marginRight: "10px" }}
                src={Avatar}
                alt="avataricon"
              />
              <div>
                {HasPermissions(INFO?.UpdateNewUserContactDetails?.actionName, PER?.ScreenPermissions?.Modify) ?
                  <a
                    variant="body2"
                    onClick={() => {
                      if (props?.userId) {
                        navigate("/userdetails?u=" + props?.userId)
                      }
                    }}
                    style={{ textDecoration: "none", color: "#101828", cursor: "pointer" }}
                  //to={"/userdetails?u=" + props?.userId}
                  >
                    <h6>{props.name}</h6>
                  </a>
                  : <h6>{props.name}</h6>
                }

                <Stack direction="row" spacing={2}>
                  <Card
                    sx={{
                      width: "15px",
                      textAlign: "center",
                      backgroundColor: "#667085",
                      marginRight: "5px",
                      color: "#fff",
                    }}
                  >
                    {props.organizationType && props.organizationType.length > 0
                      ? props.organizationType.charAt(0)
                      : ""}
                  </Card>
                  <span
                    style={{
                      color: "#667085",
                      fontWeight: "bold",
                      marginLeft: "3px",
                    }}
                  >
                    {" "}
                    {props.orgName}
                  </span>
                </Stack>
              </div>
            </Box>

            <Typography></Typography>
            <Box sx={{ color: palette.grey[80] }}> </Box>
          </Box>
          <Box width={headers.find((h) => h.id === "status")}>
            <Box sx={{ minWidth: "10%" }}>
              <Label
                role={
                  props.userStatus === true
                    ? statusRoleMap.Active.role
                    : statusRoleMap.InActive.role
                }
              >
                <Typography style={{ width: "65px", textAlign: "center" }}>
                  {props.userStatus ? "Active" : "Inactive"}
                </Typography>
              </Label>
            </Box>
          </Box>
          <Box width={headers.find((h) => h.id === "emailAddress")}>
            <Typography className="text-break">{props.email}</Typography>
          </Box>
          <Box width={headers.find((h) => h.id === "assignedRoles")}>
            <Typography>{props.userRoles}
            </Typography>
          </Box>
          <Box width={headers.find((h) => h.id == "lastLoginDate")}>
            <Typography>{GetfVDateFormate("", props.lastLoginDate)}</Typography>
          </Box>
          <Box width={headers.find((h) => h.id === "icons")}>
            <Typography>
              {HasPermissions(INFO?.UpdateNewUserContactDetails?.actionName, PER?.ScreenPermissions?.Modify) &&
                <IconButton
                  aria-label="edit"
                  onClick={() => {
                    if (props?.userId) {
                      navigate("/userdetails?u=" + props?.userId)
                    }
                  }}
                >
                  <img src={edit} alt="edit icon" />
                </IconButton>
              }
              <Dialog open={deleteDialogOpen} onClose={handleDialogClose}>
                <DialogTitle id="alert-dialog-title">
                  {"Are you sure you want to delete?"}
                </DialogTitle>
                <DialogActions className="w-100 d-flex">
                  <Button
                    label="Cancel"
                    role="secondary"
                    onClick={handleDialogClose}
                    style={{ padding: "12px" }}
                  />


                  {
                    isDeleting ? (
                      <Box
                        style={{
                          display: "flex",
                          marginLeft: "auto",
                          padding: "5px",
                        }}
                      >
                        <CircularProgress size={28} />
                      </Box>
                    ) : (
                      <Button
                        label="Yes, delete"
                        onClick={confirmDelete}
                        style={{ marginLeft: "auto", padding: "12px" }}
                      />
                    )}

                </DialogActions>
              </Dialog>

            </Typography>
          </Box>
          <Box width={headers.find((h) => h.id === "icon")}>
            <Typography>
              {HasPermissions(getOrgType() == "Client" ? INFO?.ClientOrVendorUsersList?.actionName : INFO?.SearchUser?.actionName, PER?.ScreenPermissions?.Delete) &&
                <IconButton
                  hidden={props?.userRoles == "Super User"}
                  aria-label="delete"
                  onClick={() => {
                    setDeleteDialogOpen(true);
                    setIsDeleting(false);
                  }}
                >
                  <img src={trash1} alt="delete icon" />
                </IconButton>
              }
            </Typography>
          </Box>
        </Box>
      </ThemeProvider >
    </>
  );
}
